<template>
	<div class="ce-quote">
		<blockquote cite>
			<p v-html="objectdata.text.replace('<p>','<p>&ldquo;').replace('</p>','&bdquo;</p>')"/>
			<footer>{{objectdata.quotesource}}</footer>
		</blockquote>
	</div>
</template>
<script>
	import Base from "./Base.vue";
	export default {
		extends: Base,
		props: {
			type: false,
			objectdata: {}
		},

		data() {
			return {};
		},
		created() {
			// this.init();
		},
		methods: {},
		composed: {
			getfullheadline() {
				return;
			}
		}
	};
</script>

<style lang="scss">
</style>